module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*",
      "capture": "environment"
    },
    on: {
      "change": _vm.onChangeInput
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-467974aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-barcode-reader/src/components/ImageBarcodeReader.vue
// module id = 735
// module chunks = 1